import router from '@/router.js'

export function getQuery(query) {
    const querys = router.currentRoute.query
    return querys && querys[query] ? querys[query] : false
}
export function setQuery(queryObject) {
    let querys = router.currentRoute.query
    const currentURL = router.currentRoute.path
    let newQuerys = JSON.parse(JSON.stringify(querys))
    Object.keys(queryObject).forEach(key => {
        if (queryObject[key]) {
            newQuerys[key] = queryObject[key].toString()
        }
    })
    router.replace({ path: currentURL, query: newQuerys })
}

export function removeQuery(query) {
    const currentURL = router.currentRoute.path
    if (!query) {
        return
    }
    let querys = router.currentRoute.query
    let newQuerys = JSON.parse(JSON.stringify(querys))
    delete newQuerys[query]
    router.replace({ path: currentURL, query: newQuerys })
}

export function getParam(param) {
    const params = router.currentRoute.params
    return params && params[param] ? params[param] : {}
}
